import React, { useState, cache, useEffect, useRef } from "react";
import CommonConfirmModal from "../../../components/Modal/commonConfirmModal";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  closeCache,
  closeClearCash,
} from "../../../redux/action/member/memberAction";
import { notice } from "../../../redux/action/action";
import { Flex, Image, Text, useToast } from "@chakra-ui/react";
import { waitTime } from "../../../utils/waitTime";
import { COMMON_WEB_PATH } from "../../../constant";
import { clearCashRegister } from "../../../api/postApi";
import useMyBalance from "../../../hook/useMyBalance";
import { formatNumber } from "../../../utils/formatNumber";

const ClearCashPop = ({ openModal, setModalOpen }) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);

  const dispatch = useDispatch();
  const clearCashPop = useSelector((state) => state.isClearCashPop);

  const current_balance = useMyBalance();

  const toast = useToast();

  const [buttonLoading, setButtonLoading] = useState(false);
  /* 同步鎖：buttonLoading 要等 re-render 才生效，快速連點（或觸控雙觸發）會在那之前送出第二次請求 */
  const submittingRef = useRef(false);

  const handleClearCash = async () => {
    if (submittingRef.current) return;
    submittingRef.current = true;
    try {
      setButtonLoading(true); // 設置按鈕 loading 狀態
      await clearCashRegister(); // 呼叫棄分 API
      dispatch({ type: "GET_BALANCE" });
      // 成功提示
      toast({
        title: i18n("foldSuccess"),
        status: "success",
        duration: 3000,
        isClosable: true,
      });

      dispatch(closeClearCash()); // 關閉彈窗
    } catch (error) {
      // 失敗提示
      toast({
        title: i18n("foldFailed"),
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      submittingRef.current = false;
      setButtonLoading(false); // 關閉按鈕 loading
    }
  };
  return (
    <CommonConfirmModal
      modalProps={{
        title: i18n("fold"),
        okButtonText: i18n("confirm"),
        okButtonDisabled: current_balance > 0 ? false : true,
        buttonLoading: buttonLoading,
        content: (
          <>
            <Flex
              direction={"column"}
              alignItems={"center"}
              justifyContent={"center"}
              gap="15px"
            >
              {/* <Image
                w="150px"
                src={`${COMMON_WEB_PATH}/v4-layout/clear_cache.png`}
              /> */}
              <Text>{i18n("confirm-clearCash")}</Text>
              <Text>
                ({i18n("您當前的餘額")}:{formatNumber(current_balance)})
              </Text>
            </Flex>
          </>
        ),
        cancelButtonText: i18n("cancel"),
        footerStyle: {
          display: "flex",
          flexDirection: "column",
          gap: "10px",
        },
        buttonStyle: {
          width: "100%",
          mr: "0",
          borderRadius: "10px",
          height: "40px",
        },
        confirmButtonStyle: {
          width: "100%",
          bgGradient: "linear(to-b, #4D77FB, #2755FE)",
          color: "white",
          _hover: {
            bgGradient: "linear(to-b, #2755FE, #4D77FB)",
            opacity: 0.4,
            _disabled: {
              bgGradient: "linear(to-b, #4D77FB, #2755FE)",
              opacity: 0.4,
            },
          },
          _active: {
            _disabled: {
              bgGradient: "linear(to-b, #4D77FB, #2755FE)",
              opacity: 0.4,
            },
          },
        },
      }}
      onConfirm={() => {
        handleClearCash();
      }}
      modalOpen={clearCashPop}
      size="xs"
      onClose={() => {
        dispatch(closeClearCash());
      }}
    />
  );
};

export default ClearCashPop;
